/* Delune: draw review stars on product cards that load after the reviews app has run
   (recommendations, filtered collection grids). Same markup and format as the homepage
   carousel cards: five stars plus the review count, e.g. (59). */
(function () {
  if (window.deluneStars) return;
  window.deluneStars = true;

  function fill(badge) {
    if (badge.querySelector('.r_stars')) return;
    var count = parseInt(badge.getAttribute('data-count'), 10);
    var avg = parseFloat(badge.getAttribute('data-avg'));
    if (!count || !avg) return;
    var url = badge.getAttribute('data-url') || '#';
    var pct = Math.max(0, Math.min(100, (avg / 5) * 100)).toFixed(2);
    badge.innerHTML =
      '<a href="' + url + '" tabindex="0" aria-label="Product rating (' + count + ')">' +
      '<span class="r_stars"><span class="r_stars_inner"><span class="r_stars_on" style="width:' + pct + '%"></span></span></span>' +
      '<span class="r_count">(' + count + ')</span></a>';
  }

  function run() {
    document.querySelectorAll('.card-wrapper .rapid_reviews_stars_badge[data-count]').forEach(fill);
  }

  var timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, 400);
  }

  function start() {
    schedule();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
